/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUserDTO
 */
export interface CreateUserDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateUserDTO
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDTO
     */
    password: string;
    /**
     * 
     * @type {number}
     * @memberof CreateUserDTO
     */
    accountType: CreateUserDTOAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDTO
     */
    appleIdentity?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDTO
     */
    googleIdentity?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserDTO
     */
    active: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUserDTO
     */
    roles: Array<CreateUserDTORolesEnum>;
}


/**
 * @export
 */
export const CreateUserDTOAccountTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type CreateUserDTOAccountTypeEnum = typeof CreateUserDTOAccountTypeEnum[keyof typeof CreateUserDTOAccountTypeEnum];

/**
 * @export
 */
export const CreateUserDTORolesEnum = {
    User: 'user',
    Trainer: 'trainer',
    Admin: 'admin'
} as const;
export type CreateUserDTORolesEnum = typeof CreateUserDTORolesEnum[keyof typeof CreateUserDTORolesEnum];


/**
 * Check if a given object implements the CreateUserDTO interface.
 */
export function instanceOfCreateUserDTO(value: object): value is CreateUserDTO {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('accountType' in value) || value['accountType'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function CreateUserDTOFromJSON(json: any): CreateUserDTO {
    return CreateUserDTOFromJSONTyped(json, false);
}

export function CreateUserDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
        'accountType': json['accountType'],
        'appleIdentity': json['appleIdentity'] == null ? undefined : json['appleIdentity'],
        'googleIdentity': json['googleIdentity'] == null ? undefined : json['googleIdentity'],
        'active': json['active'],
        'roles': json['roles'],
    };
}

export function CreateUserDTOToJSON(json: any): CreateUserDTO {
    return CreateUserDTOToJSONTyped(json, false);
}

export function CreateUserDTOToJSONTyped(value?: CreateUserDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'password': value['password'],
        'accountType': value['accountType'],
        'appleIdentity': value['appleIdentity'],
        'googleIdentity': value['googleIdentity'],
        'active': value['active'],
        'roles': value['roles'],
    };
}

